import { FilterParams } from '@synergy/models';
import { PaloFilterChips } from '@synergy/components-palo';
import { ReactElement } from 'react';

import { StatusListKey } from '../filter/document-status-options';
import { usePaloListFilterValues } from './use-palo-list-filters';
import { useStatusNames } from '../filter/document-status-filter';

interface PaloNamedFilterChipsProps {
    /** Which list the chips belong to, so the names can be asked of it. */
    listKey: StatusListKey;
    fields?: { key: string; type: string }[];
    currency?: string;
}

/**
 * The filter chips of a list, with the agent read as a name.
 *
 * The chips sit outside the filter panel, so they cannot ask the panel which
 * list they are on, and the filter component that knows a contact's name only
 * exists while the panel is open. The list key therefore comes in as a value,
 * and the names come from the list itself — the same answer the selection
 * inside the panel reads (#2231 R-128).
 */
export const PaloNamedFilterChips = (props: PaloNamedFilterChipsProps): ReactElement | null => {
    const agents = usePaloListFilterValues(props.listKey, 'responsibleContact');
    // A status is named the way this list's pill names it (#2340).
    const statuses = useStatusNames(props.listKey as StatusListKey);

    return (
        <PaloFilterChips
            fields={props.fields}
            currency={props.currency}
            names={{ [FilterParams.ResponsibleContactId]: agents, status: statuses }}
        />
    );
};
